import { Controller } from "@hotwired/stimulus"

// Mobile nav toggle for the BD landing header partial.
// Adds is-open class to the nav target + nav-open to body so CSS can lock
// scroll. The legacy header markup uses togglable/toggle-active classes
// driven by the Kube prod JS bundle; here we replace that contract with a
// Stimulus-owned class so the landing is independent of the prod bundle.
export default class extends Controller {
  static targets = ["nav"]

  open() {
    this.navTarget.classList.add("is-open")
    document.body.classList.add("nav-open")
  }

  close() {
    this.navTarget.classList.remove("is-open")
    document.body.classList.remove("nav-open")
  }

  toggle() {
    if (this.navTarget.classList.contains("is-open")) {
      this.close()
    } else {
      this.open()
    }
  }

  disconnect() {
    document.body.classList.remove("nav-open")
  }
}
